import { useSelector } from "react-redux";
import { RootState } from "../state";
import {
  UserRepository,
  ChannelRepository,
  MessageRepository,
  MessageContentType,
} from "@amityco/ts-sdk";

export default function CommunityService() {
  const loginData = useSelector((state: RootState) => state.login);

  const follow = async (
    userId: Amity.User["userId"],
  ): Promise<Amity.FollowStatus> => {
    const { data: followStatus } =
      await UserRepository.Relationship.follow(userId);

    return followStatus;
  };

  const unfollow = async (userId: Amity.User["userId"]): Promise<boolean> => {
    const result = await UserRepository.Relationship.unfollow(userId);

    return result;
  };

  const createChannel = async (
    userId: Amity.User["userId"],
    conversationName?: string,
  ) => {
    const newChannel = {
      // avatarFileId: 'fileId',
      displayName: conversationName ? conversationName : "conversation",
      // possible values for type = 'broadcast' | 'conversation' | 'community' | 'live';
      type: "conversation" as Amity.ChannelType,
      userIds: [userId],
    };

    const { data: channel } = await ChannelRepository.createChannel(newChannel);

    return channel;
  };

  const sendMessage = async (channel: string, messageData?: string) => {
    const textMessage = {
      subChannelId: channel,
      dataType: MessageContentType.TEXT,
      data: {
        text: messageData ? messageData : "hello world",
      },
    };

    const { data: message } =
      await MessageRepository.createMessage(textMessage);

    return message;
  };

  return {
    follow,
    unfollow,
    createChannel,
    sendMessage,
  };
}
